import React, {PureComponent} from 'react';
import styled, {withTheme} from "styled-components";
import {ScrollableContentWrapper} from "./Layout";
import {TransitionGroup} from "react-transition-group";
import {scrollTo} from "../Common/ScrollTo";
import SelectItem from './SelectItem'


const Select = styled.div`
    position: relative;
    width: 100%;
    overflow-x: hidden;
    padding-bottom: 5px;

    .fade-enter {
        opacity: 0;
        transform: translateX(40px);
    }

    .fade-enter-active {
        opacity: 1;
        transform: translateX(0);

        transition: all 500ms;
    }

    .fade-exit {
        opacity: 1;
        transform: translateX(0);
    }

    .fade-exit-active {
        transform: translateX(40px);
        opacity: 0;
        transition: all 500ms;
    }

    .fade-only-enter {
        opacity: 0;
    }

    .fade-only-enter-active {
        opacity: 1;
        transition: all 500ms;
    }

    .fade-only-exit {
        opacity: 1;
    }

    .fade-only-exit-active {
        opacity: 0;
        transition: all 500ms;
    }
`;

class SelectComponent extends PureComponent {
    state = {items: []};

    componentDidMount() {
        if (this.props.items) {
            this.setState({items: this.props.items});
        }
    }


    firstTime = true;

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.items) {
            const newPage = nextProps.items && this.props.items && this.props.items.length < nextProps.items.length;
            this.setState({items: nextProps.items}, () => {
                if (this.props.scrollToTop) {
                    this.animateTop();
                }

                if (this.props.autoScrollNewPage && newPage) {
                    setTimeout(() => {
                        scrollTo(this.scrollEl, this.scrollEl.scrollTop + this.scrollEl.offsetHeight - 110, 1000)
                    }, 100);
                }
            });
        }
    }

    animateTop() {
        if (this.firstTime) {
            this.firstTime = false;
            const designatedScrollTopPosition = Math.min((this.scrollEl.scrollHeight - this.scrollEl.offsetHeight) / 2, 200);
            if (designatedScrollTopPosition > 0) {
                this.scrollEl.scrollTop = (this.scrollEl.scrollHeight - this.scrollEl.offsetHeight) / 3;
                setTimeout(() => {
                    scrollTo(this.scrollEl, 0, 1000)
                })
            }
        }
    }

    render() {
        const {props} = this;
        const {
            keyProp,
            scrollToTop,
            quantityResolver,
            children,
            resolveItemSecondLine,
            resolveItemDescription,
            showImage
        } = props;

        const isItemSelected = (item, keyProp) => {
            if (Array.isArray(props.selected)) {
                for (let selectedIdx in props.selected) {
                    if (props.selected[selectedIdx].OnlineBookingServiceId === item.OnlineBookingServiceId) {
                        return true;
                    }
                }
            } else if (props.selected && keyProp && item[keyProp] === props.selected[keyProp]) {
                return true;
            }


            return false;
        };

        const items = this.state.items.map((item, idx) => {
            const isSelected = isItemSelected(item, keyProp);

            const key = keyProp ? item[keyProp] : (item.key + '-internal');
            return (<SelectItem
                {...this.props} item={item}
                showImage={showImage}
                transitionDelay={(idx % 15 + 1) * 50}
                resolveItemSecondLine={resolveItemSecondLine}
                resolveItemDescription={resolveItemDescription}
                key={key}
                unique={key}
                selected={isSelected}
                changeQuantity={this.props.changeQuantity}
                quantity={quantityResolver ? quantityResolver(item) : 1}
                idx={idx}></SelectItem>)
        });

        return (
            <ScrollableContentWrapper preventPaddingBottom={this.props.preventPaddingBottom}>
                <Select innerRef={el => this.scrollEl = el} className="items-picker__container">
                    {scrollToTop ? items :
                        <TransitionGroup component={null}>
                            {items}
                        </TransitionGroup>
                    }
                    {children}
                </Select>
            </ScrollableContentWrapper>
        )
    }
}

export default withTheme(SelectComponent)
